import { authGet } from './authMiddleware';

export const getCompanyFilters = async () => {
    return authGet('/api/Company/Start');
}